import { ReloadIcon } from '../../../PaymentData.styled';

export const getHeadersArray = (isFinal, reloadData) => [
	[
		<th colSpan={5}>
			<span>{isFinal ? 'Final result' : 'Pre result'}</span>
			<ReloadIcon className={'fa-solid fa-rotate'} onClick={reloadData} />
		</th>,
	],
	[
		<th>Price</th>,
		<th>For one</th>,
		<th>Confirmed orders</th>,
		<th> Delivered orders</th>,
		<th>Effective payment</th>,
	],
];
